<template>
<!-- 活动佣金配置 -->
  <div>
    <!-- 搜索/查询 -->
    <el-col :span="24" class="order_toolbar toolbar pad_left">
      <div class="main_container">
        <div class="fuji" @click="show3 = !show3">
          <p style="margin: 0; margin-left: -22px" class="goodslist1">
            <span style="margin-left: 31px; margin-top: 5px">搜索/查询</span>
            <span class="divReset" @click.stop="fnReset" ><img src="../../assets/img/Reset.png" alt/></span>
          </p>
          <div style="position: absolute; right: -19px; top: -10px" class="sanjiao"/>
        </div>
        <el-collapse-transition>
          <div style="padding: 0px 12px" v-show="show3">
            <el-form :model="filters" :inline="true" style="margin-top: 10px; display: flex" class="findform">

              <el-form-item style="display: flex; width: 30%" label="品类：">
                <el-cascader 
                v-model="filters.brandTypeId"
                  style="width:100%"
                  placeholder="请选择"
                  :options="brandTypearrList"
                  filterable
                  clearable
                  @change="getbrandarr"/>
              </el-form-item>

              <el-form-item
                style="display: flex; width: 30%"
                label="活动形式：">
                <el-select
                  v-model="filters.vipOrderStatusId"
                  placeholder="请选择"
                  style="background: #fff; width: 100%"
                  ref="mySelect">
                  <el-option
                    :label="item.Name"
                    :value="item.Id"
                    v-for="(item, index) in allStatusoptions"
                    :key="index"/>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="danger" @click="onSubmit">查询</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-collapse-transition>
      </div>
    </el-col>

    <!--列表-->
    <template>
      <el-col :span="24" class="order_content main_container">
        <section class="model_section">
          <p class="model_top_title">活动佣金配置列表</p>
          <el-button type="danger" @click="addOrEditBrand()" style="float: right;margin: 5px 10px 0 0;">新增</el-button>
        </section>
        <!-- table 列表 -->
        <div class="table_container">
          <div class="table_inner_container" style="height: auto">
            <el-table :data="dataList" class="invoice_tab" stripe border style="height: auto;">
              <el-table-column label="城市" align="center">
                <template scope="scope">
                  <span class="spanList">{{ scope.row.cityName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="品类" align="center">
                <template scope="scope">
                  <span class="spanList">{{ scope.row.goodsBrandTypeName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="活动形式" align="center">
                <template scope="scope">
                  <span class="spanList">{{ scope.row.activityModeName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="总佣金" align="center">
                <template scope="scope">
                  <span class="spanList">{{ scope.row.commissionRate }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="平台佣金比例" align="center">
                <template scope="scope">
                  <span class="spanList">{{ scope.row.platRate }}</span>
                </template>
              </el-table-column>
              <el-table-column label="会员返现比例" align="center">
                <template scope="scope">
                  <span class="spanList">{{ scope.row.returnRate }}</span>
                </template>
              </el-table-column>
              <el-table-column label="一级共创佣金比例" align="center">
                <template scope="scope">
                  <span class="spanList">{{ scope.row.firstCoRate }}</span>
                </template>
              </el-table-column>
              <el-table-column label="二级共创佣金比例" align="center">
                <template scope="scope">
                  <span class="spanList">{{ scope.row.secondRate }}</span>
                </template>
              </el-table-column> -->
              <el-table-column label="状态" align="center">
                <template scope="scope">
                  <span class="spanList">{{ scope.row.stateName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" fixed="right" width="200" align="center">
                <template scope="scope">
                  <div class="action_container">
                    <p @click="cardStatus(scope)" style="color: #6786b4; margin-left: 8px; cursor: pointer">
                      <i :class=" scope.row.state == 1 ? 'el-icon-circle-close' : 'el-icon-circle-check'"></i>
                      {{ scope.row.state == 1 ? "关闭" : "开启" }}
                    </p>
                    <p class="handle" @click="chakancontent(scope)">
                      <i class="el-icon-view"></i>查看
                    </p>
                    <p class="handle" @click="addOrEditBrand(scope.row)">
                      <i class="el-icon-edit-outline"></i>编辑
                    </p>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!--分页-->
          <el-col :span="24" style="margin-top: 15px; float: right" class="order_toolbar_footer">
            <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
              :current-page="pageIndex" :page-size="10" :total="total"/>
          </el-col>
        </div>
      </el-col>
    </template>

    <!-- 新增/编辑推广-弹框 -->
    <el-dialog title="活动佣金配置" :visible.sync="isToExamine" :center="true"
      class="add_order_cancle" width="40%" @close="cancelFun()">
      <el-form>
        <el-form-item style="width: 65%" label-width="140px" label="品类：">
          <el-cascader v-model="configure.brandTypeId" :options="brandTypearr" placeholder="请选择品类"
            style="width:100%" filterable clearable :disabled="seeDis" @change="getbrandarrFun"/>
        </el-form-item>

        <!-- <el-form-item style="width: 65%" label-width="140px" label="品类：">
          <el-select
            filterable
            v-model="configure.brandTypeId"
            placeholder="请选择品类"
            style="background: #fff; width: 100%"
            ref="mySelect"
            @change="getbrandarr"
            :disabled="seeDis">
            <el-option
              :label="item.Name"
              :value="item.Id"
              v-for="(item, index) in brandTypearr"
              :key="index"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item style="width: 65%" label-width="140px" label="活动形式：">
          <el-select v-model="configure.vipOrderStatusId" placeholder="请选择活动形式"
            style="background: #fff; width: 100%" ref="mySelect" :disabled="seeDis">
            <el-option :label="item.Name" :value="item.Id" v-for="(item, index) in statusoptions" :key="index"/>
          </el-select>
        </el-form-item>

        <el-form-item label="总佣金比例 :" style="width: 65%" label-width="140px">
          <el-input :disabled="seeDis" v-model="configure.totalCommission"
            placeholder="请输入最低佣金比例" maxlength="20"
            onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
        </el-form-item>
        <!-- <el-form-item label="客户返现比例 :" style="width: 65%" label-width="140px">
          <el-input v-model="configure.recurrence" :disabled="seeDis" placeholder="请输入客户佣金比例" maxlength="20"
            onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
        </el-form-item>
        <el-form-item label="一级共创佣金比例 :" style="width: 65%" label-width="140px">
          <el-input :disabled="seeDis" v-model="configure.oneCommissionRate"
            placeholder="请输入一级共创佣金比例" maxlength="20"
            onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
        </el-form-item>
        <el-form-item label="二级共创佣金比例 :" style="width: 65%" label-width="140px">
          <el-input :disabled="seeDis" v-model="configure.twoCommissionRate"
            placeholder="请输入二级共创佣金比例" maxlength="20"
            onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
        </el-form-item> -->
      </el-form>
      <!-- 弹框按钮 确定/取消 -->
      <div style="padding-left: 0; text-align: center">
        <button type="button" @click="cancelFun()" class="el-button el-button--default cancle normal_btn">
          取消
        </button>
        <button v-show="chakan" type="button" @click="editSubmit()" class="el-button el-button--default search_btn normal_btn">
          保存
        </button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { GetNoCommissionSettingActivityForm, GetActivityCommissionSettingList,
  GetActivityCommissionSettingById, EnableCommissionSetting, UpdateCommissionSetting,
  InsertCommissionSetting, GetCurrentUserCityList, GetBrandTypeAndNodeTree } from "../../api/comment";

export default {
  name: 'ActivityCommission',
  data() {
    return {
      show3: false,
      // 搜索框内的
      filters: {
        chengshi: "", // 城市
        vipOrderStatusId: "", // 活动形式
        brandTypeId: 0, // 商品品类
        brandId: 0, // 品牌
      },
      isToExamine: false, //新增编辑弹框
      configure: {
        //新增编辑的
        city: [],
        brandTypeId: [], // 商品品类
        vipOrderStatusId: "", // 活动形式
        vipOrderStatusName: "", // 活动形式
        totalCommission: "", //总佣金比例
        // recurrence: "", //客户返现比例
        // oneCommissionRate: "", //一级共创佣金比例
        // twoCommissionRate: "", //二级共创佣金比例
      },
      seeDis: false, //置灰
      chakan: true, // 保存按钮 默认展示
      isAdd: true, //是否是新增，true新增，false编辑

      options: [],
      statusoptions: [], //剩余的活动形式
      allStatusoptions: [], //搜索时全部的活动形式
      brandTypearr: [], //品类列表

      dataList: [], // 查询列表
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      dataListId: '',
      brandTypearrList:[]
    };
  },
  methods: {
    // 初始化
    init() {
      let addParams = {
        provinceId: this.filters.chengshi[0]||0,    //所属省份id
        cityId:  this.filters.chengshi[1]||0,        //所属城市id
        goodsTypeId: this.filters.brandTypeId[0],   //一级品类id
        goodsBrandTypeId: this.filters.brandTypeId[1],  //二级品类id
        activityModeId: this.filters.vipOrderStatusId||0,    //活动类型id
        pageIndex: this.pageIndex, // 分页数据 当前页码
        pageSize: this.pageSize, // 分页数据 每页显示条数
        userId: localStorage.Id,
      };
      GetActivityCommissionSettingList(addParams)
        .then((data) => {
          this.dataList = data.ResultObj;
          this.total = data.RowsCount;
        })
        .catch((err) => {
          this.dataList = [];
        });
    },

    //获取活动形式
    getBaseDataListFun() {
      let that = this;

      let obj = {
        cityId: 0,
        goodsBrandType: 0,
        id: 0
      }
      GetNoCommissionSettingActivityForm(obj).then((data) => {
        // 全部的活动形式
        let newdata = data.ResultObj;
        that.allStatusoptions = newdata;
        this.allStatusoptions.unshift({
          Id: 0,
          Name: "全部",
        });
      })
      .catch((err) => {});
    },

    // 获取品类
    getBrandType() {
      var obj = {
        isAsc: true,
        brandTypeId: 0
      };
      GetBrandTypeAndNodeTree(obj).then((data) => {

          data.forEach(item=>{
            item.value = item.Id;
            item.label = item.Name;
            item.children = item.BrandTypeNode;
            item.children.forEach(e=>{
              e.value = e.Id;
              e.label = e.Name;
            })
          })

          this.brandTypearr = data;       //新增编辑的品类
          this.brandTypearrList=[{        //搜索框的品类
            value: 0,
            label: "全部",
          },...data];
      });
    },
    // 切换品类时清空活动形式
    getbrandarr() {
      this.configure.vipOrderStatusId = "";
      this.configure.vipOrderStatusName = "";
    },

    // 切换品类
    getbrandarrFun(){
      this.configure.vipOrderStatusId = "";
      if(this.configure.city&&this.configure.brandTypeId){
        this.getNoCommissionSettingActivityFormFun(); //获取未配置活动佣金活动类型(在获取城市的时候调取)
      }
      
    },

    // 重置
    fnReset() {
      (this.filters = {
        chengshi: "",
        vipOrderStatusId: "", // 状态
        brandTypeId: [], // 商品品类
        brandId: 0, // 品牌
      }),
        (this.provinceId = 0);
      this.cityId = 0;
      this.queryId = "";
      this.pageIndex = 1;
      this.init();
    },

    //查询
    onSubmit() {
      this.pageIndex = 1;
      this.init();
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.init();
    },

    // 开启/关闭
    cardStatus(scope) {
      this.dataListId = scope.row.id;
      this.$swal({
        type: "warning",
        text: scope.row.state == 1 ? "是否执行关闭操作" : "是否执行开启操作",
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      }).then((res) => {
        if (res.value) {
          this.makesure(scope);
        }
      });
    },

    // 查看(查看活动佣金配置详情)
    chakancontent(scope) {
      this.seeDis = true;     //是否禁用
      this.chakan = false;    //保存按钮
      this.isToExamine = true; // 弹框展示
      this.dataListId = scope.row.id;       //活动佣金配置列表id
      this.isAdd = false
          console.log(this.isAdd,'是否是编辑11111');
      this.getActivityCommissionSettingByIdFun();   // 查看活动佣金配置详情
    },

    // 查看活动佣金配置详情
    getActivityCommissionSettingByIdFun(){
      let obj = {
        id: this.dataListId
      }
      GetActivityCommissionSettingById(obj).then(data=>{
        let datas = data.ResultObj;
        if(data.ResultCode == 1){
          this.configure.brandTypeId = [0,0]
          this.provinceId = datas.provinceId;
          this.cityId = datas.cityId;
          this.configure.city = [datas.provinceId,datas.cityId]

          this.configure.brandTypeId[0] = datas.goodsTypeId;
          this.configure.brandTypeId[1] = datas.brandTypeId;
          
          console.log(this.isAdd,'是否是编辑22222');
          if(!this.isAdd){
            this.getNoCommissionSettingActivityFormFun(); //获取未配置活动佣金活动类型(在获取城市的时候调取)
          }
          this.configure.vipOrderStatusId = datas.activityModeId;
          this.configure.vipOrderStatusName = datas.activityModeName;
          this.configure.totalCommission = datas.commissionRate
          // this.configure.recurrence = datas.returnRate
          // this.configure.oneCommissionRate = datas.firstCoRate
          // this.configure.twoCommissionRate = datas.secondRate
          
        }
      })

    },

    // 点击取消/删除按钮
    cancelFun() {
      this.isToExamine = false; // 弹框展示
      this.seeDis = false;     //是否禁用
      this.chakan = true;    //保存按钮
      // this.setConfigureFun();       //置空弹框内的填写内容
    },

    // 确定执行操作--调取开启关闭接口
    makesure(scope) {
      let obj = {
        state: scope.row.state==1?0:1,
        id: this.dataListId
      }
      EnableCommissionSetting(obj).then(data=>{
        if(data.ResultCode == 1){
          this.init();
          this.$swal({
            type:"success",
            text:"操作成功"
          })
        }
      })
    },

    /**
     * 新增编辑
     */

    // 触发 编辑按钮 & 新增按钮 是否回显
    addOrEditBrand(row) {
      // 如果有数据就是编辑 否则就是新增
      if (row) {
        
        this.dataListId = row.id;       //活动佣金配置列表id
        // 编辑的话此时调用编辑显示详情接口，回显数据
        this.isAdd = false;
        this.getActivityCommissionSettingByIdFun();   // 查看活动佣金配置详情
        
      } else {
        this.isAdd = true;
        this.setConfigureFun();       //置空弹框内的填写内容
        this.dataListId = '';
      }
      this.isToExamine = true; // 弹框展示
      this.statusoptions = [];
    },

    //获取未配置活动佣金活动类型
    getNoCommissionSettingActivityFormFun(){
      let obj = {
        cityId: this.cityId,
        goodsBrandType: this.configure.brandTypeId[1],
        id: this.dataListId||0
      }
      GetNoCommissionSettingActivityForm(obj).then(data=>{
        if(data.ResultCode == 1){
          data.ResultObj.forEach(e=>{
            e.value = e.Id;
            e.label = e.Name;
          })
          // 活动形式数组
          this.statusoptions = data.ResultObj;
        }
        if(data.ResultCode == 4){
          this.statusoptions = [];
        }
      })
    },

    // 保存按钮
    editSubmit() {
      if (this.configure.city == ""||this.configure.city.length<1) {
        this.$swal({
          type: "warning",
          text: "请选择城市",
        });
        return false;
      }
      if (this.configure.brandTypeId == null||this.configure.brandTypeId.length<1) {
        this.$swal({
          type: "warning",
          text: "请选择品类",
        });
        return false;
      }
      if ( this.configure.vipOrderStatusId == "" || this.configure.vipOrderStatusId == null ) {
        this.$swal({
          type: "warning",
          text: "请选择活动形式",
        });
        return false;
      }
      if ( this.configure.totalCommission == "" || this.configure.totalCommission == null ) {
        this.$swal({
          type: "warning",
          text: "请输入总佣金比例",
        });
        return false;
      }
      if (
        !this.configure.totalCommission ||
        Number(this.configure.totalCommission) < 5 ||
        Number(this.configure.totalCommission) > 99
      ) {
        this.$swal({
          text: "总佣金比例,需输入5%-99%之间的数字",
          type: "warning",
        });
        return false;
      }
      // if ( this.configure.recurrence == "" || this.configure.recurrence == null){
      //   this.$swal({
      //     type: "warning",
      //     text: "请输入客户返现比例",
      //   });
      //   return false;
      // }
      // if ( !this.configure.recurrence ||
      //   Number(this.configure.recurrence) < 0 ||
      //   Number(this.configure.recurrence) > this.configure.totalCommission){
      //   this.$swal({
      //     text: `客户返现比例,需输入0%-${this.configure.totalCommission}%之间的数字`,
      //     type: "warning",
      //   });
      //   return false;
      // }
      // if (
      //   this.configure.oneCommissionRate == "" ||
      //   this.configure.oneCommissionRate == null
      // ) {
      //   this.$swal({
      //     type: "warning",
      //     text: "请输入一级共创佣金比例",
      //   });
      //   return false;
      // }
      // if ( !this.configure.oneCommissionRate ||
      //   Number(this.configure.oneCommissionRate) < 0 ||
      //   Number(this.configure.oneCommissionRate) > 49
      // ) {
      //   this.$swal({
      //     text: "一级共创佣金比例,需输入0%-49%之间的数字",
      //     type: "warning",
      //   });
      //   return false;
      // }
      // if (
      //   this.configure.twoCommissionRate == "" ||
      //   this.configure.twoCommissionRate == null
      // ) {
      //   this.$swal({
      //     type: "warning",
      //     text: "请输入二级共创佣金比例",
      //   });
      //   return false;
      // }
      // if ( !this.configure.twoCommissionRate ||
      //   Number(this.configure.twoCommissionRate) < 0 ||
      //   Number(this.configure.twoCommissionRate) > 49
      // ) {
      //   this.$swal({
      //     text: "二级共创佣金比例,需输入0%-49%之间的数字",
      //     type: "warning",
      //   });
      //   return false;
      // }
      // 判断是编辑还是新增
      if (!this.isAdd) {
        this.updateCommissionSettingFun();
      } else {
        this.insertCommissionSettingFun();
      }
    },

    // 新增活动佣金配置
    insertCommissionSettingFun(){
      var loginParams = {
        provinceId: this.provinceId, // 所属省份
        cityId: this.cityId, // 所属城市
        brandTypeId: this.configure.brandTypeId[1], // 二级品类id
        activityModeId: this.configure.vipOrderStatusId, // 活动类型
        commissionRate: this.configure.totalCommission, // 佣金比例
        // returnRate: this.configure.recurrence, // 返现比例
        // firstCoRate: this.configure.oneCommissionRate, // 一级共创佣金
        // secondCoRate: this.configure.twoCommissionRate, // 二级共创佣金
        operatorId: localStorage.Id, // 当前操作人id
      };
      InsertCommissionSetting(loginParams).then(data => {
        if (data.ResultCode == 1) {
          data = data.ResultObj;
          this.$swal({
            text:"新增活动佣金配置保存成功",
            type: "success"
          })
          this.isToExamine = false;
          this.init();
          this.setConfigureFun();       //置空弹框内的填写内容
        }
      })
    },

    // 修改活动佣金配置
    updateCommissionSettingFun(){
      var loginParams = {
        provinceId: this.provinceId, // 所属省份
        cityId: this.cityId, // 所属城市
        brandTypeId: this.configure.brandTypeId[1], // 二级品类id
        activityModeId: this.configure.vipOrderStatusId, // 活动类型
        commissionRate: this.configure.totalCommission, // 佣金比例
        // returnRate: this.configure.recurrence, // 返现比例
        // firstCoRate: this.configure.oneCommissionRate, // 一级共创佣金
        // secondCoRate: this.configure.twoCommissionRate, // 二级共创佣金
        id: this.dataListId, // 活动配置主键id，随列表返回
      };
      UpdateCommissionSetting(loginParams).then(data => {
        if (data.ResultCode == 1) {
          data = data.ResultObj;
          this.$swal({
            text:"编辑活动佣金配置保存成功",
            type: "success"
          })
          this.isToExamine = false;
          this.init();
          this.setConfigureFun(); // 置空弹框内的填写内容
        }
      })
    },

    // 置空弹框内的填写内容
    setConfigureFun(){
        this.configure.city = [];
        this.configure.brandTypeId = null;
        this.configure.vipOrderStatusId = "";
        this.configure.vipOrderStatusName = "";
        this.configure.totalCommission = "";
        // this.configure.recurrence = "";
        // this.configure.oneCommissionRate = "";
        // this.configure.twoCommissionRate = "";
        this.cityId = "";
        this.provinceId = "";
    },
  },
  created() {
    let that = this;
    // 获取省
    this.getprovince();
    // 获取搜索栏全部的活动形式
    this.getBaseDataListFun();
    // 获取品类
    this.getBrandType();
    // 查询列表
    setTimeout(function () {
      that.init();
    }, 200);
    this.queryId = this.$route.query.consumptionUserId;
  },
  mounted() {},
};
</script>
<style scoped>
/* 表格操作 */
.action_container {
  color: #677c9d;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// ActivityCommission.vue?0e9d5f3a